import { render, staticRenderFns } from "./ExternalRequestDetails.vue?vue&type=template&id=0385be06"
import script from "./ExternalRequestDetails.vue?vue&type=script&lang=js"
export * from "./ExternalRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports